var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"small right"),React.createElement("g",{"className":"nc-icon-wrapper","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1},React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeMiterlimit":"10","points":"10,8 14,12 10,16 ","transform":"translate(0, 0)"}))]);
}

ArrowRight.defaultProps = {"viewBox":"0 0 24 24","width":"24","height":"24"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
